import {getTemplate} from '../../utils/api';
import {getAttachmentBlock} from '../../utils/attachments';
import $ from 'jquery';

export default {
  methods: {
    useTemplate(template) {
      this.isSelectTemplateModal = false;
      getTemplate(template.id).then(template => {

        if (this.isTemplate) {
          this.templateName = template.name;
          if(this.selectFolderChoices) {
            this.selectFolderChoices.setValueByChoice(template.folder_id);
          }
        }

        let msgText = template.body;
        let attachmentInfo = null;

        if (template.attachment) {
          attachmentInfo = {
            type: 'add-photo',
            link: template.attachment,
          };
        }
        else {
          let firstLine = msgText.split(/\r\n|\r|\n/)[0].trim();
          attachmentInfo = getAttachmentBlock(firstLine, true);

          if ('type' in attachmentInfo && attachmentInfo.type !== 'none') {
            msgText = msgText.replace(firstLine, '').trim();
          }
        }
        this.attachmentInfo = attachmentInfo;

        $('#new-msg').data('emojioneArea').setText(msgText);

        this.onTxtChange();
      });
    },
  },
};